import { MailToHyperlink } from '@strata/react-hyperlink';

import { Overview } from 'components/shared/Overview';
import { Section } from 'components/shared/Section';

const brandguidelinesOverview = [
    <div key="1">
        <p>
            Brand guidelines are rules and standards that communicate how our brand should be
            represented to the world. Brand guidelines help businesses ensure consistency and
            demonstrate what the company is, what it does, and what it stands for.
        </p>
        <p>
            These guidelines have been developed through careful consideration of many factors, both
            functional and aesthetic. Adhering to these design standards will ensure that the Free
            Market Health brand is always expressed clearly and with quality.
        </p>
        <h4 className="margin__top--large">
            For questions related to marketing or brand guidelines please reach out to:
        </h4>
        <MailToHyperlink
            linkText="Marketing Team"
            subject="Brand Guidelines Question"
            emailAddress="marketingcommunications@freemarkethealth.com"
        />
    </div>,
];

export const BrandGuidelinesOverview = () => (
    <Overview
        title="Brand Guidelines Overview"
        description="Free Market Health's Brand Guidelines will help you design compelling communications with consistency and creativity."
        image="https://sseasacdn.blob.core.windows.net/strata-website/brand-guidelines-overview.svg"
        content={
            <Section title="What are Brand Guidelines?" contentArray={brandguidelinesOverview} />
        }
    />
);
